var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"image-zoom-container"},[_c('img',{ref:"image",attrs:{"src":_vm.imageUrl,"alt":"Zoomable Image"}}),_c('v-btn',{staticStyle:{"z-index":"20001"},attrs:{"small":"","text":"","depressed":""},on:{"click":_vm.reset}},[_vm._v("Reset")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }